import MassBalanceTable from './MassBalanceTable'
import { useEffect, useRef, useState } from 'react'
import api from '../../services/api'
import { useMassBalancePage } from '../../contexts/MassBalancePageContext'
import StrategicChart from '../GoogleCharts/StrategicChart'
import GanttChart from '../GoogleCharts/Gantt'
import { useUser }              from '../../contexts/UserContext.js';


function MassBalanceTableContainer() {


    const [massBalanceData, setMassBalanceData] = useState([])
    const [loading, setLoading] = useState(false)

    // Número da busca mais recente, para ignorar respostas que chegam atrasadas.
    const { userData } = useUser();
    
    const lastRequestRef = useRef(0)

    const {
        selectedTerminal,
        selectedDate,
        selectedProducts

    } = useMassBalancePage();

    const fetchMassBalanceData = async () => {

        const requestNumber = ++lastRequestRef.current

        if (!selectedTerminal || !selectedDate || !selectedProducts || selectedProducts.length === 0) {
            setMassBalanceData([])
            return
        }

        try {
            console.log('Fetching mass balance data...')

            setLoading(true)

            // "Todos" traz a lista de terminais; um terminal só vira uma lista de um.
            const terminais = selectedTerminal.isAll ? selectedTerminal.terminals : [selectedTerminal]

            // Uma busca por terminal x produto selecionado que tiver esse produto.
            const requests = terminais
                .flatMap((terminal) => selectedProducts.map((selectedProduct) => ({
                    terminalId: terminal.id,
                    productId: selectedProduct.idByTerminal
                        ? selectedProduct.idByTerminal[terminal.id]
                        : selectedProduct.id
                })))
                .filter(({ productId }) => productId !== undefined)

            const responses = await Promise.all(
                requests.map(({ terminalId, productId }) => api.get('/getMassBalanceFiltered', {
                    params: {
                        terminalId,
                        massBalancePostReferenceDate: selectedDate,
                        productId
                    }
                }))
            )

            if (requestNumber !== lastRequestRef.current) return

            setMassBalanceData(responses.flatMap((response) => response.data || []))

        } catch (error) {
            if (requestNumber !== lastRequestRef.current) return

            console.error('Erro ao buscar os dados do Mass Balance:', error)
            setMassBalanceData([])
        } finally {
            if (requestNumber === lastRequestRef.current) setLoading(false)
        }
    }

    useEffect(() => {
        fetchMassBalanceData()
    }, [

        selectedTerminal,
        selectedDate,
        selectedProducts
    ])

    const strategicChartData = [...massBalanceData]
        .sort((firstRow, secondRow) => new Date(firstRow.date) - new Date(secondRow.date))
        .map((row) => ({
            date: row.date,
            value:      Number(row.final),
            railway:    Number(row.railway),
            static:     Number(row.static),
            road:       Number(row.road)
        }))
        .filter(({ date, value, railway, static: staticValue, road }) => (
            date
            && Number.isFinite(value)
            && Number.isFinite(railway)
            && Number.isFinite(staticValue)
            && Number.isFinite(road)
        ))

    return (

        <div>
            <div className="text-end text-gray-500">
                <i>Total de linhas: {massBalanceData.length}</i>
            </div>

            <MassBalanceTable tableRows={massBalanceData} />

        </div>
    )
}

export default MassBalanceTableContainer